/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './new-information.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../dropdowncalendar/dropdowncalendar.component.ngfactory';
import * as i4 from '../../../../../app/shared/components/dropdowncalendar/dropdowncalendar.component';
import * as i5 from '../../../../../app/plan/service/plan-main.service';
import * as i6 from '../../../../../app/services/globalvariable.service';
import * as i7 from '../../../../../app/services/util.service';
import * as i8 from '@angular/forms';
import * as i9 from '../../../../../app/shared/directives/focus.directive';
import * as i10 from '../dialog-maxlength/dialog-maxlength.component.ngfactory';
import * as i11 from '../../../../../app/shared/components/dialog-maxlength/dialog-maxlength.component';
import * as i12 from '../../../../../app/shared/components/new-information/new-information.component';
import * as i13 from '../../../../../app/services/news.service';
import * as i14 from '@angular/router';
const styles_NewInformationComponent:any[] = [i0.styles];
export const RenderType_NewInformationComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NewInformationComponent,data:{}});
function View_NewInformationComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'p',[['class',
      'box-news-date']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['','.','.',''])),i1.ɵpid(0,i2.SlicePipe,([] as any[])),
      i1.ɵpid(0,i2.SlicePipe,([] as any[])),i1.ɵpid(0,i2.SlicePipe,([] as any[]))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = i1.ɵunv(_v,1,0,i1.ɵnov(_v,2).transform((<any>_v.parent).context.$implicit.date,
            0,4));
        const currVal_1:any = i1.ɵunv(_v,1,1,i1.ɵnov(_v,3).transform((<any>_v.parent).context.$implicit.date,
            4,6));
        const currVal_2:any = i1.ɵunv(_v,1,2,i1.ɵnov(_v,4).transform((<any>_v.parent).context.$implicit.date,
            6,8));
        _ck(_v,1,0,currVal_0,currVal_1,currVal_2);
      });
}
function View_NewInformationComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',[['class',
      'box-news-title']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(1,(null as any),['[','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.title;
    _ck(_v,1,0,currVal_0);
  });
}
function View_NewInformationComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),12,'div',[['class',
      'news-list']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.editNewsItems(_v.context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewInformationComponent_2)),
      i1.ɵdid(3,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewInformationComponent_3)),
      i1.ɵdid(6,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),
          1,'p',[['class','last-frame']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[']'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n          '])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(11,(null as any),['',''])),
      (_l()(),i1.ɵted(-1,(null as any),['\n        ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.date;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _v.context.$implicit.title;
    _ck(_v,6,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.body;
    _ck(_v,11,0,currVal_2);
  });
}
function View_NewInformationComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'p',[['class',
      'no-data']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['新着情報は、ありません']))],(null as any),(null as any));
}
function View_NewInformationComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'btnclose'],['id','saveBtn']],(null as any),[[(null as any),'click']],(_v,en,
      $event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.addNews()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['登録']))],(null as any),
      (null as any));
}
function View_NewInformationComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'btnclose'],['id','saveBtn']],(null as any),[[(null as any),'click']],(_v,en,
      $event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.updateNews()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['登録']))],(null as any),
      (null as any));
}
function View_NewInformationComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),66,'div',[['aria-hidden',
      'true'],['aria-labelledby','exampleModalLabel'],['class','modal'],['role','dialog'],
      ['style','display: block;'],['tabindex','-1']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),63,'div',[['class','modal-dialog'],['role',
          'document']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),(_l()(),i1.ɵeld(4,0,(null as any),
          (null as any),44,'div',[['class','modal-body']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),2,'div',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(7,0,(null as any),(null as any),1,'span',[['class','close']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onEditNews(false)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['×'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),9,'div',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(12,0,(null as any),(null as any),1,'span',[['class','title-label']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['日付'])),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(15,0,(null as any),(null as any),3,'app-dropdowncalendar',[['style',
          'ime-mode: disabled'],['type','tel']],(null as any),[[(null as any),'onDatevalue'],
          [(null as any),'onfocusouts'],[(null as any),'keydown.enter']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('onDatevalue' === en)) {
          const pd_0:any = ((<any>_co.getDateValue($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('onfocusouts' === en)) {
          const pd_1:any = ((<any>_co.getDateValue($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('keydown.enter' === en)) {
          const pd_2:any = ((<any>_co.enterKey($event,'title')) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },i3.View_DropdowncalendarComponent_0,i3.RenderType_DropdowncalendarComponent)),
      i1.ɵdid(16,770048,(null as any),0,i4.DropdowncalendarComponent,[i5.PlanMainService,
          i6.GlobalvariableService,i7.UtilService],{date:[0,'date'],formatdate:[1,
          'formatdate'],onicon:[2,'onicon'],defaultDate:[3,'defaultDate'],style:[4,
          'style'],styletextbox:[5,'styletextbox'],maxLength:[6,'maxLength'],inputId:[7,
          'inputId']},{onDatevalue:'onDatevalue',onfocusouts:'onfocusouts'}),i1.ɵpod(17,
          {'width':0}),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵeld(21,0,(null as any),(null as any),12,'div',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵeld(23,0,(null as any),(null as any),
          1,'span',[['class','title-label']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['題名'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(26,0,(null as any),
          (null as any),6,'input',[['class','ipt-title ime_a'],['id','title'],['type',
              'text']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown.enter'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focusout'],[(null as any),'keyup'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,27)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,27).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,27)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,27)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focusout' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,32).onFocusout($event)) !== false);
              ad = (pd_4 && ad);
            }
            if (('keyup' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,32).onkeyup($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('focus' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,32).onFocus($event)) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.newsTitle = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('keydown.enter' === en)) {
              const pd_8:any = ((<any>_co.enterKey($event,'body')) !== false);
              ad = (pd_8 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(27,16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(29,671744,(null as any),0,i8.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(31,16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(32,
          81920,(null as any),0,i9.AutofocusDirective,[i1.ElementRef,i1.Renderer,i7.UtilService],
          {wordstr:[0,'wordstr'],mxLen:[1,'mxLen'],autofocus:[2,'autofocus']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(35,0,(null as any),(null as any),12,'div',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(37,0,(null as any),
          (null as any),1,'span',[['class','title-label']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['本文'])),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(40,
          0,(null as any),(null as any),6,'textarea',[['class','ime_a'],['id','body'],
              ['rows','5']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'keydown.enter'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focusout'],[(null as any),'keyup'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,41)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,41).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,41)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,41)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('focusout' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,46).onFocusout($event)) !== false);
              ad = (pd_4 && ad);
            }
            if (('keyup' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,46).onkeyup($event)) !== false);
              ad = (pd_5 && ad);
            }
            if (('focus' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,46).onFocus($event)) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.newsDetail = $event)) !== false);
              ad = (pd_7 && ad);
            }
            if (('keydown.enter' === en)) {
              const pd_8:any = ((<any>_co.enterKey($event,'saveBtn')) !== false);
              ad = (pd_8 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(41,16384,(null as any),0,i8.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i8.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i8.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i8.DefaultValueAccessor]),i1.ɵdid(43,671744,(null as any),0,i8.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i8.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i8.NgControl,(null as any),[i8.NgModel]),i1.ɵdid(45,16384,(null as any),
          0,i8.NgControlStatus,[i8.NgControl],(null as any),(null as any)),i1.ɵdid(46,
          81920,(null as any),0,i9.AutofocusDirective,[i1.ElementRef,i1.Renderer,i7.UtilService],
          {wordstr:[0,'wordstr'],mxLen:[1,'mxLen'],autofocus:[2,'autofocus']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(50,
          0,(null as any),(null as any),14,'div',[['class','modal-footer']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n      '])),(_l()(),i1.ɵeld(52,0,(null as any),(null as any),
          5,'div',[['class','float-left']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵeld(54,0,(null as any),(null as any),0,'input',[['name','show'],
          ['type','radio']],[[8,'checked',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.isShowNews(1)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' 表示\n        '])),
      (_l()(),i1.ɵeld(56,0,(null as any),(null as any),0,'input',[['name','show'],
          ['type','radio']],[[8,'checked',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.isShowNews(0)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),[' 非表示\n      '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NewInformationComponent_6)),i1.ɵdid(60,
          16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewInformationComponent_7)),
      i1.ɵdid(63,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.date0;
    const currVal_1:any = 'yy/mm/dd';
    const currVal_2:any = true;
    const currVal_3:any = 'off';
    const currVal_4:any = 'ime-mode: disabled';
    const currVal_5:any = _ck(_v,17,0,'125px');
    const currVal_6:any = 8;
    const currVal_7:any = 'date';
    _ck(_v,16,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_15:any = _co.newsTitle;
    _ck(_v,29,0,currVal_15);
    const currVal_16:any = 100;
    const currVal_17:any = true;
    const currVal_18:any = true;
    _ck(_v,32,0,currVal_16,currVal_17,currVal_18);
    const currVal_26:any = _co.newsDetail;
    _ck(_v,43,0,currVal_26);
    const currVal_27:any = 1600;
    const currVal_28:any = true;
    const currVal_29:any = true;
    _ck(_v,46,0,currVal_27,currVal_28,currVal_29);
    const currVal_32:boolean = !_co.isUpdate;
    _ck(_v,60,0,currVal_32);
    const currVal_33:any = _co.isUpdate;
    _ck(_v,63,0,currVal_33);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_8:any = i1.ɵnov(_v,31).ngClassUntouched;
    const currVal_9:any = i1.ɵnov(_v,31).ngClassTouched;
    const currVal_10:any = i1.ɵnov(_v,31).ngClassPristine;
    const currVal_11:any = i1.ɵnov(_v,31).ngClassDirty;
    const currVal_12:any = i1.ɵnov(_v,31).ngClassValid;
    const currVal_13:any = i1.ɵnov(_v,31).ngClassInvalid;
    const currVal_14:any = i1.ɵnov(_v,31).ngClassPending;
    _ck(_v,26,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_19:any = i1.ɵnov(_v,45).ngClassUntouched;
    const currVal_20:any = i1.ɵnov(_v,45).ngClassTouched;
    const currVal_21:any = i1.ɵnov(_v,45).ngClassPristine;
    const currVal_22:any = i1.ɵnov(_v,45).ngClassDirty;
    const currVal_23:any = i1.ɵnov(_v,45).ngClassValid;
    const currVal_24:any = i1.ɵnov(_v,45).ngClassInvalid;
    const currVal_25:any = i1.ɵnov(_v,45).ngClassPending;
    _ck(_v,40,0,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,
        currVal_25);
    const currVal_30:any = (_co.newsEnabled == 1);
    _ck(_v,54,0,currVal_30);
    const currVal_31:any = (_co.newsEnabled == 0);
    _ck(_v,56,0,currVal_31);
  });
}
function View_NewInformationComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-dialog-maxlength',
      ([] as any[]),(null as any),[[(null as any),'close']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('close' === en)) {
          const pd_0:any = ((<any>_co.oncloseDialog()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i10.View_DialogMaxlengthComponent_0,i10.RenderType_DialogMaxlengthComponent)),
      i1.ɵdid(1,114688,(null as any),0,i11.DialogMaxlengthComponent,[i1.ElementRef],
          {inputname:[0,'inputname'],showEmpty:[1,'showEmpty']},{close:'close'})],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.inputName;
        const currVal_1:any = true;
        _ck(_v,1,0,currVal_0,currVal_1);
      },(null as any));
}
export function View_NewInformationComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),37,'div',[['aria-hidden',
      'true'],['aria-labelledby','exampleModalLabel'],['class','modal'],['role','dialog'],
      ['style','display: block;'],['tabindex','-1']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n\n  '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),34,'div',[['class','modal-dialog'],
          ['role','document']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(4,
          0,(null as any),(null as any),4,'div',[['class','modal-header']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n      新着情報マスタ\n      '])),(_l()(),i1.ɵeld(6,0,(null as any),
          (null as any),1,'button',[['class','btnclose float-right']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.NewInformationComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onEditNews(true)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['新規　新着情報を追加する'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(10,0,(null as any),(null as any),19,'div',[['class',
          'modal-body']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵeld(12,0,(null as any),
          (null as any),7,'div',[['class','btn-head-wrap']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i1.ɵeld(14,0,(null as any),(null as any),1,'button',
          [['class','btn-red']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.NewInformationComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.prevPage()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['前の10件へ'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(17,0,(null as any),
          (null as any),1,'button',[['class','btn-red']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.NewInformationComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.nextPage()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['次の10件へ'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵeld(21,0,(null as any),(null as any),7,'div',
          [['class','content-wrap']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewInformationComponent_1)),
      i1.ɵdid(24,802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_NewInformationComponent_4)),i1.ɵdid(27,16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(31,
          0,(null as any),(null as any),4,'div',[['class','modal-footer']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n      '])),(_l()(),i1.ɵeld(33,0,(null as any),(null as any),
          1,'button',[['class','btnclose']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.NewInformationComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onClose()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['閉じる'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_NewInformationComponent_5)),i1.ɵdid(40,16384,(null as any),
          0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NewInformationComponent_8)),i1.ɵdid(43,
          16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i12.NewInformationComponent = _v.component;
    const currVal_0:any = _co.newsList;
    _ck(_v,24,0,currVal_0);
    const currVal_1:any = (((_co.newsList == null)? (null as any): _co.newsList.length) == 0);
    _ck(_v,27,0,currVal_1);
    const currVal_2:any = _co.editnews;
    _ck(_v,40,0,currVal_2);
    const currVal_3:any = _co.displayError;
    _ck(_v,43,0,currVal_3);
  },(null as any));
}
export function View_NewInformationComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-new-information',
      ([] as any[]),(null as any),(null as any),(null as any),View_NewInformationComponent_0,
      RenderType_NewInformationComponent)),i1.ɵdid(1,245760,(null as any),0,i12.NewInformationComponent,
      [i5.PlanMainService,i13.NewsService,i7.UtilService,i14.Router],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NewInformationComponentNgFactory:i1.ComponentFactory<i12.NewInformationComponent> = i1.ɵccf('app-new-information',
    i12.NewInformationComponent,View_NewInformationComponent_Host_0,{},{close:'close'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/components/new-information/new-information.component.ngfactory.ts